import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = { class: "content-wrapper__tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "content-header" }
const _hoisted_5 = { class: "flex scroll-content word-stats__header" }
const _hoisted_6 = { class: "content-checkboxes" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "word-stats-cell" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "on-desktop" }, "Hide words", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "on-desktop" }, "Show words", -1)
const _hoisted_11 = {
  key: 0,
  class: "translation-cell"
}
const _hoisted_12 = {
  key: 1,
  class: "ml-1"
}
const _hoisted_13 = { class: "flex-column-start" }
const _hoisted_14 = { class: "flex-column-start" }
const _hoisted_15 = { class: "table__actions" }

import { computed, onMounted, reactive, ref, watch } from 'vue';
import { useWordStatsStore } from '@/stores/word-stats';
import { useBlockListsStore } from '@/stores/blocks';
import { useTitle, watchDebounced } from '@vueuse/core';
import { useConfirmModal } from '@/stores/confirm-modal';
import { useDataStore } from '@/stores/data';
import { useRepliesStore } from '@/stores/replies';
import TheHeader from '@/components/TheHeader.vue';
import SearchIcon from '@/components/icons/other/SearchIcon.vue';
import VSocialSelect from '@/components/VSocialSelect.vue';
import VAuthInput from '@/components/VAuthInput.vue';
import VDatePicker from '@/components/VDatePicker.vue';
import Table from '@/components/Table.vue';
import VBlockListSelect from '@/components/VBlockListSelect.vue';
import VReplySetSelectStats from '@/components/VReplySetSelectStats.vue';
import AssetsCell from '@/components/AssetsCell.vue';
import VPagination from '@/components/VPagination.vue';
import VCheckbox from '@/components/VCheckbox.vue';
import VButton from '@/components/VButton.vue';
import ViewIcon from '@/components/icons/actions/ViewIcon.vue';
import ViewOffIcon from '@/components/icons/actions/ViewOffIcon.vue';
import VIconButton from '@/components/VIconButton.vue';
import VChips from '@/components/VChips.vue';
import { useUiStore } from '@/stores/ui';
import FileSearchIcon from '@/components/icons/other/FileSearchIcon.vue';
import { useTooltip } from '@/stores/tooltip';
import { useDialogStore } from '@/stores/dialogs';
import DrilldownDialog from '@/components/dialogs/DrilldownDialog.vue';
import { useTabs } from '@/utils/hooks/use-tabs';


export default /*#__PURE__*/_defineComponent({
  __name: 'WordStats',
  setup(__props) {

const socialValue = ref<string | null>(null)

const selectedBusiness = reactive(new Set<{ id: number, name: string, picture?: string }>())

const columns = {
  word: { title: "Word", width: 250, minWidth: 230 },
  translation: { title: "Translation" },
  mentions: { title: "Mentions", sort: true },
  block_lists: { title: "Blocklist", width: 220 },
  replies_sets: { title: "Replies  Set", width: 220, fallback: "-" },
  involved_assets: { title: "Involved assets", minWidth: 120, fallback: "-" },
  actions: { title: "", width: 30 }
}

const { currentTab, tabs } = useTabs([
  { id: "bm", name: "BMs", path: "bms" },
  { id: "pages", name: "Pages", path: "pages" },
  { id: "ad_accounts", name: "Ad accounts", path: "ad-accounts" },
])
watch(currentTab, (value) => {
  wordStatsStore.params.groupby_id = [ "bm", "pages", "ad_accounts" ].indexOf(value)+1
})

const wordStatsStore = useWordStatsStore()
const blockListStore = useBlockListsStore()
const repliesStore = useRepliesStore()
let mounted = false
onMounted(async () => {
  mounted = true
  await wordStatsStore.requestAll()
  await blockListStore.requestAll()
  await repliesStore.requestReplies()
})

const currentData = computed(() => {
  return wordStatsStore.wordStats
})

watch(() => wordStatsStore.queryParams, async () => {
  if (!mounted) return
  await wordStatsStore.requestAll()
})

watch(socialValue, (value) => {
  if (value === null) {
    delete wordStatsStore.params.connect_ids
  }
  if (value === "fb") {
    wordStatsStore.params.connect_ids = [ 1, 2 ]
  }
  if (value === "tiktok") {
    wordStatsStore.params.connect_ids = [ 3 ]
  }
})

const dataStore = useDataStore()
watchDebounced(selectedBusiness, async (selected) => {
  const _values: { filter_business_ids: number[], filter_page_ids: number[], filter_ad_account_ids: number[] } = { filter_business_ids: [], filter_page_ids: [], filter_ad_account_ids: []  }
  for (let item of dataStore.businesses) {
    if (selected.has(item)) _values.filter_business_ids.push(item.id)
  }
  for (let item of dataStore.pages) {
    if (selected.has(item)) _values.filter_page_ids.push(item.id)
  }
  for (let item of dataStore.ad_accounts) {
    if (selected.has(item)) _values.filter_ad_account_ids.push(item.id)
  }
  for (let [_key, value] of Object.entries(_values)) {
    const key = _key as "filter_business_ids" | "filter_page_ids" | "filter_ad_account_ids"
    if (value.length > 0) {
      wordStatsStore.params[key] = value
    } else {
      wordStatsStore.params[key] = undefined
    }
  }
}, { debounce: 400 })

const searchValue = ref("")
watchDebounced(searchValue, (value) => {
  wordStatsStore.params.search = value
}, { debounce: 400 })

useTitle("Word Stats | Reply200")

const actionHide = computed(() => {
  for (let item of selected) {
    if (item.active !== false && item.active !== "false") return true
  }
  return false
})

const selected = reactive(new Set<any>())

const confirmModal = useConfirmModal()
const hideWords = (e: MouseEvent, items: any[]) => {
  const hide = items.find(item => item.active !== false && item.active !== "false")
  if (hide) {
    confirmModal.open(e, `Are you sure you want to hide this ${items.length === 1? 'word': 'words'}?`, async () => {
      await wordStatsStore.hide(items)
      selected.clear()
    })
  } else {
    confirmModal.open(e, `Are you sure you want to show this ${items.length === 1? 'word': 'words'}?`, async () => {
      await wordStatsStore.show(items)
      selected.clear()
    })
  }
}

const period = ref<any>("all")
const uiStore = useUiStore()
watch([period, () => uiStore.customDate], () => {
  const params = uiStore.getDateParam(period.value)
  Object.assign(wordStatsStore.params, params)
}, { immediate: true })

const tooltip = useTooltip()

const dialogStore = useDialogStore()
const openDrilldown = (item: any) => {
  dialogStore.open(DrilldownDialog, { word: item.original_word })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TheHeader, { title: "Word Stats" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab) => {
          return (_openBlock(), _createElementBlock("button", {
            class: _normalizeClass({ active: _unref(currentTab) === tab.id }),
            onClick: ($event: any) => (currentTab.value = tab.id)
          }, _toDisplayString(tab.name), 11, _hoisted_3))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(VSocialSelect, {
            modelValue: socialValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((socialValue).value = $event)),
            class: "mr-2"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(VCheckbox, {
              modelValue: _unref(wordStatsStore).params.filter_no_block_list,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(wordStatsStore).params.filter_no_block_list) = $event)),
              label: "No Blocklist"
            }, null, 8, ["modelValue"]),
            _createVNode(VCheckbox, {
              modelValue: _unref(wordStatsStore).params.filter_no_replies_set,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(wordStatsStore).params.filter_no_replies_set) = $event)),
              label: "No Replies set"
            }, null, 8, ["modelValue"]),
            _createVNode(VCheckbox, {
              modelValue: _unref(wordStatsStore).params.filter_show_hidden,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(wordStatsStore).params.filter_show_hidden) = $event)),
              label: "Show hidden"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(VAuthInput, {
            modelValue: searchValue.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchValue).value = $event)),
            icon: SearchIcon,
            placeholder: "Search",
            class: "light search",
            clearable: ""
          }, null, 8, ["modelValue"]),
          _createVNode(VDatePicker, {
            modelValue: period.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((period).value = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createVNode(Table, {
        modelValue: selected,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(selected) ? (selected).value = $event : null)),
        columns: columns,
        data: _unref(currentData),
        "row-key": "word",
        checkable: "",
        "default-sort": "mentions",
        "search-field": "word",
        loading: !_unref(wordStatsStore).loaded,
        "enabled-key": "active",
        sort: _unref(wordStatsStore).params.sort,
        "onUpdate:sort": _cache[9] || (_cache[9] = ($event: any) => ((_unref(wordStatsStore).params.sort) = $event)),
        "disable-inner-sort": ""
      }, {
        word: _withCtx(({ cell, item }) => [
          _createElementVNode("div", _hoisted_8, [
            _createTextVNode(_toDisplayString(cell) + " ", 1),
            _createVNode(VIconButton, {
              class: "word-stats__drilldown",
              onClick: ($event: any) => (openDrilldown(item)),
              onMouseenter: _cache[6] || (_cache[6] = ($event: any) => (_unref(tooltip).showTooltip($event, 'Drilldown', 'top')))
            }, {
              default: _withCtx(() => [
                _createVNode(FileSearchIcon)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        "alt-header": _withCtx(() => [
          _createVNode(VButton, {
            secondary: "",
            density: "",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (hideWords($event, Array.from(selected.values()))))
          }, {
            default: _withCtx(() => [
              (_unref(actionHide))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(ViewIcon),
                    _hoisted_9
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(ViewOffIcon),
                    _hoisted_10
                  ], 64))
            ]),
            _: 1
          })
        ]),
        translation: _withCtx(({ item, cell }) => [
          (!!cell)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(cell), 1))
            : _createCommentVNode("", true),
          (cell !== 'en')
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.translation_word), 1))
            : _createCommentVNode("", true)
        ]),
        involved_assets: _withCtx(({ cell }) => [
          _createVNode(AssetsCell, { items: cell }, null, 8, ["items"])
        ]),
        block_lists: _withCtx(({ item, cell }) => [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(VBlockListSelect, {
              word: item.word,
              "word-item": item,
              selected: [],
              "ignore-items": cell,
              small: ""
            }, null, 8, ["word", "word-item", "ignore-items"]),
            _createVNode(VChips, { items: cell }, null, 8, ["items"])
          ])
        ]),
        replies_sets: _withCtx(({ item, cell }) => [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(VReplySetSelectStats, {
              word: item.word,
              "ignore-items": cell
            }, null, 8, ["word", "ignore-items"]),
            _createVNode(VChips, { items: cell }, null, 8, ["items"])
          ])
        ]),
        actions: _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(VIconButton, {
              onClick: ($event: any) => (hideWords($event, [ item ]))
            }, {
              default: _withCtx(() => [
                (item.active && item.active !== 'false')
                  ? (_openBlock(), _createBlock(ViewIcon, { key: 0 }))
                  : (_openBlock(), _createBlock(ViewOffIcon, { key: 1 }))
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "data", "loading", "sort"]),
      _createVNode(VPagination, {
        meta: _unref(wordStatsStore).meta,
        onChangepage: _unref(wordStatsStore).setPage
      }, null, 8, ["meta", "onChangepage"])
    ])
  ], 64))
}
}

})